import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerEntraIdKoppelnAdmin laden';
export const POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerEntraIdKoppelnAdmin ausführen';
export const POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerEntraIdKoppelnAdmin laden erfolgreich';
export const POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerEntraIdKoppelnAdmin Ladefehler';
export const POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerEntraIdKoppelnAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerEntraIdKoppelnAdminAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraIdKoppelnAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN_AUSFUEHREN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraIdKoppelnAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraIdKoppelnAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraIdKoppelnAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerEntraIdKoppelnAdminActions =
    PostBenutzerEntraIdKoppelnAdminAction
    | PostBenutzerEntraIdKoppelnAdminAusfuehrenAction
    | PostBenutzerEntraIdKoppelnAdminErfolgreichAction
    | PostBenutzerEntraIdKoppelnAdminFehlerAction
    | PostBenutzerEntraIdKoppelnAdminNichtAusgefuehrtAction
    ;
